// Standard Cube Colors
export const YELLOW = { value: "#FFFF00" };
export const RED = { value: "#FF0000" };
export const BLUE = { value: "#0000FF" };
export const WHITE = { value: "#FFFFFF" };
export const ORANGE = { value: "#FFA500" };
export const GREEN = { value: "#00FF00" };
// Extra colors for megaminx
export const PURPLE = { value: "#800080" };
export const GREY = { value: "#808080" };
export const DARK_BLUE = { value: "#00008B" };
export const LIGHT_YELLOW = { value: "#ffffb3" };
export const LIGHT_GREEN = { value: "#32CD32" };
export const PINK = { value: "#FF69B4" };
export const BLACK = { value: "#000000" };
export const MASK_COLOR = { value: "#404040" };
// Stickerless
export const YELLOW_STICKERLESS = {
    value: "#FFFF00",
    stroke: "#DDDD00",
};
export const RED_STICKERLESS = { value: "#FF0000", stroke: "#DD0000" };
export const BLUE_STICKERLESS = { value: "#0000FF", stroke: "#0000DD" };
export const WHITE_STICKERLESS = { value: "#FFFFFF", stroke: "#DDD" };
export const ORANGE_STICKERLESS = {
    value: "#FFA500",
    stroke: "#DD8500",
};
export const GREEN_STICKERLESS = {
    value: "#00FF00",
    stroke: "#00DD00",
};
export const PURPLE_STICKERLESS = {
    value: "#800080",
    stroke: "#5c005c",
};
export const GREY_STICKERLESS = { value: "#808080", stroke: "#6b6b6b" };
export const DARK_BLUE_STICKERLESS = {
    value: "#00008B",
    stroke: "#000075",
};
export const LIGHT_YELLOW_STICKERLESS = {
    value: "#ffffb3",
    stroke: "#e6e6a3",
};
export const LIGHT_GREEN_STICKERLESS = {
    value: "#32CD32",
    stroke: "#2db32d",
};
export const PINK_STICKERLESS = { value: "#FF69B4", stroke: "#de5b9c" };
